const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'heic'];

export const isImageUpload = (file) => {
    if (file?.upload_type?.startsWith('image/')) return true;
    const ext = file?.upload_name?.split('.').pop()?.toLowerCase();
    return IMAGE_EXTENSIONS.includes(ext);
};

/** Travelers, packaging photos, and BOMs are super-admin only in the Files tab. */
export const isSuperAdminOnlyUpload = (file) =>
    file?.is_bom === true || !!file?.is_traveler || !!file?.is_packaging_photo;

export const isUploadVisibleToUser = (file, user) => {
    if (user?.is_super_admin) return true;
    return !isSuperAdminOnlyUpload(file);
};

export const getVisibleUploads = (files, user) =>
    (files || []).filter((file) => isUploadVisibleToUser(file, user));

/** Fetch full upload bytes and return a blob object URL (caller should revoke when done). */
export const fetchUploadBlobObjectUrl = async (fileId, token, baseUrl, signal) => {
    const res = await fetch(`${baseUrl}/apis/uploads/${fileId}/file`, {
        headers: { Authorization: token },
        signal,
    });
    if (!res.ok) {
        throw new Error('Failed to fetch upload file');
    }
    const blob = await res.blob();
    return URL.createObjectURL(blob);
};

/** Merge create-upload API results into an existing uploads list (deduped by id). */
export const appendUploadsFromResults = (prevFiles, results) => {
    if (!Array.isArray(results) || results.length === 0) {
        return prevFiles;
    }

    const newUploads = results.map((result) => result?.upload).filter(Boolean);
    if (newUploads.length === 0) {
        return prevFiles;
    }

    const existingIds = new Set((prevFiles || []).map((file) => file.id));
    const toAdd = newUploads.filter((upload) => !existingIds.has(upload.id));
    if (toAdd.length === 0) {
        return prevFiles;
    }

    return [...toAdd, ...(prevFiles || [])];
};
